import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const LocalizationFilledIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				stroke="transparent"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4441 1C14.7981 1.0011 17.0451 1.98607 18.6418 3.71527C20.2233 5.44113 21.0212 7.74261 20.8482 10.077C20.4717 14.8016 18.2129 19.1762 14.5794 22.2186C13.9785 22.7253 13.2179 23.0022 12.431 23C11.6474 23.0011 10.8879 22.7286 10.2837 22.2295C6.65571 19.1894 4.40119 14.8192 4.02581 10.1011C3.84196 7.75384 4.64636 5.43681 6.24531 3.70871C7.84313 1.9817 10.0911 0.998908 12.4441 1ZM12.5 13.5C14.433 13.5 16 11.933 16 10C16 8.06701 14.433 6.5 12.5 6.5C10.567 6.5 9 8.06701 9 10C9 11.933 10.567 13.5 12.5 13.5Z"
			/>
		</>
	),
});
